import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMember} from '../../../graphql/groups.datatypes';
import {gqlRoomPartyMember} from '../../GroupBookings/getGroupBooking.api';

export interface UpdateRoomPartyMemberInput {
    data: {
        id: number
        room_party_id?: number
        group_member_id?: number
        primary_occupant?: boolean
        billing_party_id?: number
        guest_number?: number
        start_date?: string
        end_date?: string
    }
}

interface UpdateRoomPartyMemberData {
    __typename?: string,
    updateRoomPartyMember: RoomPartyMember
}

export const UPDATE_ROOM_PARTY_MEMBER_MUTATION = gql`
    mutation updateRoomPartyMember($data: UpdateRoomPartyMemberInput!) {
        updateRoomPartyMember(data: $data) {
            ${gqlRoomPartyMember}
        }
    }
`;

export const updateRoomPartyMember = () => useMutation<UpdateRoomPartyMemberData, UpdateRoomPartyMemberInput>(
    UPDATE_ROOM_PARTY_MEMBER_MUTATION,
    {
        update: updateCacheByType('RoomPartyMember'),
    }
);

export default updateRoomPartyMember;